import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";
const PropertyState = {
  addProperty: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-property`,
      requestOptions,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getProperty: async (params) => {
    // console.log("params", params);
    // FETCH API CALL For all notes
    const response = await axios.get(`${BASE_URL}/api/v2/admin/get-property`, {
      params,
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    // console.log("property-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getPropertyById: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getbyid-property/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },

  deleteProperty: async (id) => {
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-property/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateProperty: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.put(
      `${BASE_URL}/api/v2/admin/update-property/${id}`,
      requestOptions,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("res", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updatePropertyById: async (id, updatedFiles) => {
    // FETCH API CALL For all files
    await axios.put(
      `${BASE_URL}/api/v2/admin/single-property/${id}`,
      updatedFiles,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token"),
        },
      }
    );
  },

  updatePropertyStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/property-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updatePropertyShareCount: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/property-share/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default PropertyState;
